import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const CurrentStepCard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const current_position = location.state?.current_position;
  const id = location.state?.id;
  const owner_id = location.state?.owner_id;
  console.log("uselocation current step", location.state);

  const handleNavigation = async (tab) => {
    if (tab === "request") {
      navigate("/propertie-req-edit", {
        state: {
          type: "edit",
          owner_id: owner_id,
          id: id,
          current_position: current_position,
        },
      });
    } else if (tab === "verify") {
      if (current_position === "verify" || current_position === "mmc") {
        navigate("/propertie-doc-edit", {
          state: {
            type: "edit",
            owner_id: owner_id,
            id: id,
            current_position: current_position,
          },
          replace: true,
        });
      }
    } else {
      if (current_position === "mmc") {
        navigate("/propertie-mmc-edit", {
          state: {
            type: "edit",
            owner_id: owner_id,
            id: id,
            current_position: current_position,
          },
        });
      }
    }
  };

  return (
    <div className="d-flex ac-jb">
      <div className="d-flex ac-jb ">
        <p
          onClick={() => {
            handleNavigation("request");
          }}
          className={`f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ${
            current_position === "verify" || current_position === "mmc"
              ? "prop-act-tab pointer"
              : "prop-on-tab"
          } `}
        >
          Property Request
        </p>
        <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-line"></p>
        <p
          onClick={() => {
            handleNavigation("verify");
          }}
          className={`f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ${
            current_position === "mmc" ? "prop-act-tab pointer" : "prop-on-tab"
          }`}
        >
          Document Verification
        </p>
        <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-line" />
        <p
          onClick={() => {
            handleNavigation("mmc");
          }}
          className="f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-on-tab"
        >
          MMC
        </p>
      </div>
    </div>
  );
};

export default CurrentStepCard;
